import { useSelector } from 'react-redux';

import PropTypes from 'prop-types';
import classNames from 'classnames';

import {
  Announcement,
  Card,
  CreditsIcon,
  InfoFilledIcon,
  LockIcon,
  RadioFilledIcon,
  RadioIcon,
} from '@utilities';

import styles from './_index.module.scss';

const CreditCard = ({ isSelected, onClick }) => {
  const surveyInfo = useSelector((state) => state.user?.data?.surveyInfo);

  const promoCredits = surveyInfo?.promoCredits ?? 0;
  const userCredits = surveyInfo?.userCredits ?? 0;

  const availableCredits = userCredits + promoCredits;

  return (
    <Card
      className={classNames(styles['credit-card'], {
        [styles['is-disabled']]: !availableCredits,
        [styles['is-selected']]: isSelected,
      })}
      onClick={availableCredits ? onClick : undefined}
      padding="large"
    >
      <div className={styles['credit-card-content']}>
        <div className={styles['credit-card-title-row']}>
          <span className={styles['credit-card-radio-icon']}>
            {!availableCredits ? <LockIcon /> : isSelected ? <RadioFilledIcon /> : <RadioIcon />}
          </span>

          <h3 className={styles['credit-card-title']}>Use Your Credits</h3>
          <span className={styles['credit-card-icon']}>
            <CreditsIcon />
          </span>
        </div>
        <div>
          <p>
            Your credits:&nbsp;
            <strong>
              {userCredits.toLocaleString()} credit{userCredits !== 1 ? 's' : ''}
            </strong>
          </p>

          {promoCredits > 0 && (
            <p>
              Promotional credits:&nbsp;
              <strong>
                {promoCredits.toLocaleString()} credit
                {promoCredits !== 1 ? 's' : ''}
              </strong>
            </p>
          )}
        </div>
        {!availableCredits && (
          <Announcement
            className={styles['credit-card-announcement']}
            icon={<InfoFilledIcon />}
            text="To enable credits, contact your Numerator team."
            variant="info"
          />
        )}
      </div>
    </Card>
  );
};
CreditCard.propTypes = {
  isSelected: PropTypes.bool.isRequired,
  onClick: PropTypes.func,
};

export default CreditCard;
